import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';

import {
  formatDate,
  formatTrackingNumber,
} from '#common/utils';
import EnhancedTable, { EnhancedTableData, EnhancedTableHeader } from '#components/EnhancedTable';

interface UserShippingInfoProps {
  shippingInfo: EnhancedTableData;
  isInvoice?: boolean;
}

export default function UserShippingInfo(props: UserShippingInfoProps) {
  const { shippingInfo, isInvoice } = props;
  const { t } = useTranslation('order');

  if (!shippingInfo.rows.length) {
    return null;
  }

  const tableHeaders: EnhancedTableHeader[] = [{
    id: 'trackingNumber',
    label: t('shippingTable.trackingNumber'),
    renderer: (n) => {
      const trackingLink = formatTrackingNumber(n.trackingNumber as string);
      return <a href={trackingLink.link ?? undefined} target="_blank" rel="noreferrer">{n.trackingNumber as string}</a>;
    },
  }, {
    id: 'shipper',
    label: t('shippingTable.shipper'),
  }, {
    id: 'shipDate',
    label: t('shippingTable.shipDate'),
    renderer: (o) => formatDate(o.shipDate as string | number | Date),
  }];

  if (!isInvoice) {
    tableHeaders.push({
      id: 'barcodeItems',
      label: t('shippingTable.items'),
      renderer: (o) => (o.barcodeItems as string[]).map((bi) => <div key={bi}>{bi}</div>),
    });
  }

  return (
    <Box sx={{ mb: 5 }}>
      <EnhancedTable
        name="tracking-number"
        headers={tableHeaders}
        {...shippingInfo}
      />
    </Box>
  );
}
